import comp from "./TextAreaInput";
export { default as FormTextAreaInput } from "./FormTextAreaInput";
export default comp;
